import request from 'oc-request';

export default (formFields = {}) => ({
    ...formFields,
    errors: {},
    loading: false,

    init() {
        this.resetFields();
    },

    submitForm(action, redirectUrl = null) {
        this.errors = {};
        this.loading = true;

        request.sendData(action, {
            data: this.getFormData(),
            success: () => {
                if (redirectUrl) {
                    window.location.href = redirectUrl;
                }
            },
            complete: () => {
                this.loading = false;
                console.log('complete');
            },
            error: (response) => {
                console.log('error');
                if (response.responseJSON && response.responseJSON.errors) {
                    this.errors = response.responseJSON.errors;
                }
            },
            loading: '.preloader-selector'
        });
    },

    getFormData() {
        const data = {};
        Object.keys(formFields).forEach(key => {
            data[key] = this[key];
        });
        return data;
    },

    resetFields() {
        Object.keys(formFields).forEach(key => {
            this[key] = formFields[key] || null;
        });
    },

    hasError(field) {
        return this.errors.hasOwnProperty(field);
    },

    getError(field) {
        return this.hasError(field) ? this.errors[field][0] : '';
    }
});